
import styled from "styled-components"
import { useContext, useState } from "react";
import { MainContext } from "../../utils/context";
import MGCard from "../MGCard";
import { ALL_ANIMAL_INFO } from "../../utils/data";


let StyledBoardContainer = styled.div`
    padding: 10px 20px;
    margin-left: auto;
    margin-right: auto;
    width: 1000px;
    height: 1050px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
    align-content: flex-start;
    background-color: azure;
    border: thin solid black;

  

    @media screen and (max-width: 900px){
        width: 90%;
        height: 1000px;
      
    }
`

const StyledBoardTitle = styled.h2`
    flex: 1 1 100%;
    text-align: center;
    font-size: 4vw;

   
`

function getRandomizedBoard(){
    let newBoard = new Array(16);
    let temp_copy = Array.from(ALL_ANIMAL_INFO)
    let temp_copy2 = Array.from(ALL_ANIMAL_INFO)
    let all_guitar_info = temp_copy.concat(temp_copy2)
  
    while(all_guitar_info.length > 0){
        let randomIdx = Math.floor(Math.random()*all_guitar_info.length)
        let removedGuitar = all_guitar_info.splice(randomIdx,1)
     
        newBoard.push(Object.assign({},removedGuitar[0]))
    }

    return newBoard;
}

export const MGBoardContainer = (props) => {
    const board = getRandomizedBoard();
  
    const [currentBoard,setCurrentBoard] = useState(board);
    const [firstCardIndex,setFirstCardIndex] = useState(-1);
    const [totalMatched,setTotalMatched] = useState(0);

    const getTotalMatched = () => {
        return currentBoard.filter((guitarInfo) => { return guitarInfo.isMatched }).length/2
     }

    const BoardTitle = (props) => {
       

        return (<StyledBoardTitle>
            {totalMatched === 8 ? "You won!" : "Total Matches: " + totalMatched}
            
        </StyledBoardTitle>);
    }



    

    const flip = (index) => {
        if(index === firstCardIndex || currentBoard[index].isMatched){

            return;
        }

        if(firstCardIndex === -1){
           
            currentBoard[index].isFlipped = true;
            setFirstCardIndex(index);

        } else {

            let firstCardName = currentBoard[firstCardIndex].name;
            let secondCardName = currentBoard[index].name;

            if(firstCardName === secondCardName){

             
                currentBoard[firstCardIndex].isMatched = true;
                currentBoard[index].isMatched = true;
                currentBoard[index].isFlipped = true;
                setFirstCardIndex(-1);
            } else {
                
                currentBoard[index].isFlipped = true;
                setFirstCardIndex(-2);

                let unflipCards = () => {
                    currentBoard[firstCardIndex].isFlipped = false;
                    currentBoard[index].isFlipped = false;
                    setFirstCardIndex(-1);
                    
                }
                
                setTimeout(unflipCards,1000);
                
            }

           
            
        }
       
    
            
        let newTotal = getTotalMatched();
        setTotalMatched(newTotal);
     
    }

    return (
        <div>
       
        <StyledBoardContainer id="board-container">
        <BoardTitle></BoardTitle>
       
        {currentBoard.map((guitarInfo,index) => {
            return <MGCard flip={flip} key={guitarInfo.name+index} cardIndex={index} guitarInfo={guitarInfo}></MGCard>
        })}
    </StyledBoardContainer></div>);
}